import { convertAutocompleteItemToApi, formDateFilter } from "@monorepo/utils/src/api/convertFiltersToApi";
import { ITableFiltersObject } from "@monorepo/utils/src/store/types/tableFiltersObject";
import { fields } from "@monorepo/utils/src/variables/projectsData/versionCatalogView/fields";

export const convertFiltersCustomToApi = (resultFilters: ITableFiltersObject): void => {
  formDateFilter(resultFilters, "createAt");
  convertAutocompleteItemToApi(resultFilters, fields.FILTER_PARENT, `fieldFilters.${fields.FILTER_PARENT}.id`);
};
